module.exports = __webpack_public_path__ + "img/box1.3171803d.png";